.all-day-events {
  display: flex;
  flex-shrink: 0;
  border-bottom: var(--rc-calendar-border-base);

  .all-day-event {
    position: relative;
    flex: 1;
    min-width: 0;
  }

  .time-col {
    display: flex;
    position: relative;
    box-sizing: border-box;
    align-items: center;
    justify-content: center;
    width: var(--rc-calendar-hour-width);
    border-right: var(--rc-calendar-border-base);

    .all-day-text {
      color: var(--rc-calendar-color-text-secondary);
      font-size: var(--rc-calendar-font-size-text-sm);
    }
  }

  .week-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    flex: 1;

    > div {
      box-sizing: border-box;
      border-right: var(--rc-calendar-border-base);

      &:nth-of-type(7) {
        border-right: 0;
      }
    }
  }
}
